
import Product from "@/types/Product";
import { computed, defineComponent, PropType, ref } from "vue";
import Button from "../Buttons/Button.vue";
import ProductDeleteModal from "./ProductDeleteModal.vue";
import PrintProductPriceTag from "./PrintProductPriceTag.vue";

export default defineComponent({
  props: {
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    canDelete: {
      type: Boolean,
      default: () => false,
    },
    showPrintButton: {
      type: Boolean,
      default: () => true,
    },
  },
  setup(props) {
    const productLink = computed(() => {
      return `/l-products/view-product/${props.product.id}`;
    });

    const deleteOpen = ref(false);
    const printPriceTagOpen = ref(false);

    return {
      deleteOpen,
      productLink,
      printPriceTagOpen,
    };
  },
  components: { Button, ProductDeleteModal, PrintProductPriceTag },
});
